// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs-trigger-leading_root__nYKFG"};